var React = require('react');

function IconAnaylticsLine (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#9e9e9e","d":"M22.818 8a2.173 2.173 0 0 0-2.105 2.719l-3.873 3.857a2.237 2.237 0 0 0-1.135 0l-2.782-2.762a2.177 2.177 0 1 0-4.211 0l-4.974 4.928a2.163 2.163 0 1 0 1.549 1.538l4.964-4.94a2.237 2.237 0 0 0 1.135 0l2.781 2.76a2.177 2.177 0 1 0 4.211 0l3.884-3.846A2.167 2.167 0 1 0 22.818 8z","transform":"translate(-1 -8)"}));
}

IconAnaylticsLine.defaultProps = {"width":"24","height":"13","viewBox":"0 0 24 13"};

module.exports = IconAnaylticsLine;

IconAnaylticsLine.default = IconAnaylticsLine;
